export function toGraphqlArray<T extends number | string>(array: T[]): string {
  return `{${array.join(',')}}`;
}
